<template>
  <Main>
    <v-container>
      <v-row justify="center">
        <v-col>
          <v-card class="mx-auto">
            <v-card-text>
              <div class="text--primary">
                <v-row>
                  <v-col md="6" sm="6">                    
                    <p class="display-1 text--primary">Mapping Salesrep</p>
                  </v-col>
                  <v-col md="6" sm="6">
                    <h5 class="mb-2" style="color: red;">Pastikan mapping position di IMAPS sudah sesuai dengan position di KAPPABEL.
Apabila posisi di KAPPABEL belum sesuai, maka dibuat PA Transfer.</h5>
                 </v-col>
                </v-row>
                <v-row>
                  <v-col md="6" sm="6">
                    <v-btn color="warning" @click="downloadCSV()">Export Excel</v-btn>
                  </v-col>
                  <v-col md="6" sm="6">
                    <v-text-field
                      color="red darken-1"
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search Mapping"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col class="text-right" md="12">
                    <v-data-table
                      :headers="dtHeaders"
                      :items="dtItems"
                      :search="search"
                      :loading="dtLoading"
                      loading-text="Fetching Data..."
                      @click:row="getDataSalesRepData"
                    ></v-data-table>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading" style="z-index: 9999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- POPUP EDIT -->
    <v-dialog v-model="isOpenModalPopupEdit" max-width="75%">
      <v-card>
        <v-card-title class="headline"></v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col md="12">
                <v-text-field
                  color="red darken-1"
                  v-model="editData.SALESREPEMPLOYEENAME"
                  label="Name"
                  readonly
                ></v-text-field>
                <v-text-field
                  color="red darken-1"
                  v-model="editData.SALESREPEMPLOYEEID"
                  label="SalesRep No"
                  readonly
                ></v-text-field>
                <v-autocomplete
                  color="red darken-1"
                  v-model="selectedPosition"
                  :items="listPosition"
                  :loading="isPreparingForm"
                   item-text="ROLE_POSITION_CODE"
                  :return-object="true"
                  label="Position"
                  @change="changePosition()"
                ></v-autocomplete>
                <v-text-field
                  color="red darken-1"
                  v-model="editData.SALESREPTITLECODE"
                  label="Salesman Title"
                  required
                ></v-text-field>
                <v-text-field
                  color="red darken-1"
                  v-model="editData.SUPERVISOR"
                  label="Supervisor"
                  required
                ></v-text-field>
                
                <!-- selectedPosition -->
                 <v-text-field
                  color="red darken-1"
                  v-model="editData.CSO"
                  label="CSO"
                  readonly
                ></v-text-field>
                <!-- <v-autocomplete
                  color="red darken-1"
                  v-model="editData.CSO"
                  :items="listCSO"
                  :loading="isPreparingForm"
                  item-text="ROLE_POSITION_CODE"
                  :return-object="true"
                  label="CSO"
                  @change="changeCSO"
                ></v-autocomplete> -->
                
                <v-menu
                  v-model="isShowStartDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      color="red darken-1"
                      v-model="editData.STARTDATE"
                      label="Start Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editData.STARTDATE"
                    @input="isShowStartDate = false"
                    color="red darken-1"
                  ></v-date-picker>
                </v-menu>
                <v-menu
                  v-model="isShowEndDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      color="red darken-1"
                      v-model="editData.ENDDATE"
                      label="End Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editData.ENDDATE"
                    @input="isShowEndDate = false"
                    @change="verificationEndDate()"
                    color="red darken-1"
                  >
                    <template>
                      <v-card-actions class="w-100 float-right">
                        <v-btn small color="warning" @click="setEndDateofThisMonth()"
                          >Select End date of Last Month</v-btn
                        >
                      </v-card-actions>
                    </template>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="12">
                <h3 class="mb-2">History</h3>
                <hr class="mb-2" />
                <v-data-table
                  color="red darken-1"
                  :headers="dtHeaderHistory"
                  :items="dtItemHistory"
                  :loading="dtHistoryLoading"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  loading-text="Fetching Data..."
                ></v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="isOpenModalPopupEdit = false"
            >Cancel</v-btn
          >
          
          <v-btn  v-if="this.dtValidPeriod" color="blue darken-1" text @click="confirmModal(cutoff)">Cut Off</v-btn>
          <v-btn  v-if="this.dtValidPeriod" color="green darken-1" text @click="confirmModal(submit)">Submit</v-btn>
          <v-btn  v-if="!this.dtValidPeriod" color="green darken-1" text >Periode sudah ditutup.</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- POPUP EDIT -->
    <!-- Start Validation Submit -->
    <v-dialog v-model="isOpenModalConfirm" max-width="500px">
      <v-card>
        <v-card-title class="headline">Are you Sure to Continue ?</v-card-title>

        <v-card-text>
          It will save input data to database. Please give confirmation before you
          continue.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="isOpenModalConfirm = false"
            >Cancel</v-btn
          >

          <v-btn color="green darken-1" text @click="methodAction">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End Validation Submit -->
  </Main>
</template>

<script>
import Main from "../../Main.vue";
import moment, { months } from "moment";
import XLSX from "xlsx";
import { log } from 'handlebars/runtime';

const dtHeaders = [
  {
    text: "Name",
    value: "SALESREP_EMPLOYEE_NAME",
  },
  {
    text: "Sales Rep No",
    value: "SALESREP_EMPLOYEEID",
  },
  {
    text: "Branch",
    value: "Branch",
  },
  {
    text: "Category",
    value: "SALESREP_TYPE_CODE",
  },
  {
    text: "Salesman Title",
    value: "SALESREP_TITLE_CODE",
  },
  {
    text: "Position",
    value: "SALESREP_POSITION_CODE",
  },
  {
    text: "Position Kappabel ",
    value: "POSITION_CODE_HCM",
  },
  {
    text: "Start",
    value: "SALESREP_START_DATE",
  },
  {
    text: "End",
    value: "SALESREP_END_DATE",
  },
  {
    text: "Status",
    value: "STATUS",
  },
];

export default {
  components: {
    Main,
  },
  data() {
    return {
      dtHeaderHistory: [
        {
          text: "Position",
          value: "SALESREP_POSITION_CODE",
        },
        {
          text: "Salesman Title",
          value: "SALESREP_TITLE_CODE",
        },
        {
          text: "Supervisor",
          value: "SUPERVISOR",
        },
        {
          text: "Start Date",
          value: "START_DATE",
        },
        {
          text: "End Date",
          value: "END_DATE",
        },
        {
          text: "Status",
          value: "STATUS",
        },
      ],
      sortBy: "STATUS",
      sortDesc: false,
      dtItemHistory: [],
      selectedPosition: [],
      selectedCSO: [],
      isShowStartDate: false,
      isShowEndDate: false,
      isPreparingForm: false,
      isOpenModalPopupEdit: false,
      methodAction: "",
      isOpenModalConfirm: false,
      dtHeaders,
      dtItems: [],
      search: "",
      dtLoading: false,
      dtHistoryLoading: false,
      isShowSnackbar: false,
      snackbarText: "",
      isLoading: false,
      editData: [],
      listPosition: [],
      listCSO: [],
      dtValidPeriod: false
    };
  },
  mounted() {
    this.loadDataTable();
    // this.loadLOVPosition();
    this.cekPeriod();
  },
  watch: {
    isOpenModalPopupEdit: function (val) {
      if (!val) {
        this.dtItemHistory = [];
        this.editData = [];
        this.selectedPosition = [];
        this.selectedCSO = []
      }
    },
  },
  methods: {
     cekPeriod() {
            const userData = JSON.parse(localStorage.getItem("userData"));
              this.isLoading = true;
            let data = {
                typeID: 'MAPPING SALESREP',
                orgID :  userData.ORG_ID
            };
            this.$http
                .post("/setting/validPeriod", data, {
                  headers: {
                    "api-key": this.$apiKey
                  }
                })
                .then(res => {
                   this.isLoading = false;
                    const {
                        success,
                        message,
                        data
                    } = res.data;
                    if(data.length>0){                      
                      this.dtValidPeriod = true;
                    }else{                        
                      this.dtValidPeriod = false;
                    }
                })
                .catch(err => {
                    this.isLoading = false;
                    this.showSnackbar(err.toString());
                });
        },
    setEndDateofThisMonth() {
      this.editData.ENDDATE = moment()
        .subtract(1, "months")
        .endOf("month")
        .format("YYYY-MM-DD");
      this.isShowEndDate = false;
    },
    downloadCSV() {
      this.isLoading = true;

      this.$http
        .post("/structure/mapping-sales-rep-assignment/exportCSV", {
          orgID: JSON.parse(localStorage.getItem("userData")).ORG_ID,
        }, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          //  console.log(res);
          const { data } = res.data;
          data.forEach((val, index) => {
            data[index].SALESREP_START_DATE = moment(
              data[index].SALESREP_START_DATE
            ).format("YYYY-MM-DD");
            data[index].SALESREP_END_DATE = moment(data[index].SALESREP_END_DATE).format(
              "YYYY-MM-DD"
            );
          });
          const workBook = XLSX.utils.book_new(); // create a new blank book
          const workSheet = XLSX.utils.json_to_sheet(res.data.data);
          XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
          XLSX.writeFile(workBook, "Mapping Sales Rep.xlsx"); // initiate a file download in browser
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    confirmModal: function (method) {
      this.isOpenModalConfirm = true;
      this.methodAction = method;
    },
    loadLOVPosition(BRANCHCODE, SALESREP_POSITION_CODE, SALESREP_EMPLOYEEID) {
      console.log('BRANCHCODE ', BRANCHCODE)
      console.log('SALESREP_EMPLOYEEID ', SALESREP_EMPLOYEEID)
      this.isPreparingForm = true;
      this.$http
        .post("/structure/mapping-sales-rep-assignment/selectPositionMappingSalesrep", {
          branchCode: BRANCHCODE,
          salesRepEmployeeID : SALESREP_EMPLOYEEID
        }, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          this.isPreparingForm = false;
          const data = res.data.data;
          this.listPosition = data;

          console.log("data selectPositionMappingSalesrep : ", data);

          const X = this.listPosition.find((el) => {
            //  console.log(el.ROLE_POSITION_CODE === SALESREP_POSITION_CODE);
            return el.ROLE_POSITION_CODE === SALESREP_POSITION_CODE;
          });

          if (X != undefined) {
            this.selectedPosition = X;
            this.editData.BRANCH_CODE = X.BRANCH_CODE;
            this.editData.ORG_ID = X.ORG_ID;
            this.editData.EMPLOYEETYPEID = X.EMPLOYEE_TYPE_ID;
            this.editData.EMPLOYEETYPECODE = X.EMPLOYEE_TYPE_CODE;
            this.editData.ROLEMAPID = X.ROLE_MAP_ID;
            this.editData.SALESREPPOSITIONCODE = X.ROLE_POSITION_CODE;
            this.editData.EMPLOYEETITLEID = X.EMPLOYEE_TITLE_ID;
            // this.editData.SALESREPTITLECODE = X.EMPLOYEE_TITLE_CODE;
            // this.editData.SUPERVISOR = X.ROLE_SUP_CODE;
            this.editData.CSO = X.CSO_CODE;
            this.editData.USERIDUPDATE = JSON.parse(
              localStorage.getItem("userData")
            ).USER_ID;
          }
        })
        .catch((err) => {
          //  console.log(err);
          this.isPreparingForm = false;
          this.showSnackbar(err.toString());
        });
    },
    loadLOVCSO(SALESREP_POSITION_CODE, CSONAME, ORGID) {
      this.isPreparingForm = true;
      this.$http
        .post("/structure/mapping-sales-rep-assignment/selectCSO", {
          orgid:ORGID
        }, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          this.isPreparingForm = false;
          const data = res.data.data;
          this.listCSO = data;
          this.selectedCSO = data;

          console.log("data selectcso : ", data);

          const X = data.find((el) => {
            return el.ROLE_POSITION_CODE === CSONAME;
          });
          if (X != undefined) {
            this.selectedPosition = X;
            this.editData.USERIDUPDATE = JSON.parse(
              localStorage.getItem("userData")
            ).USER_ID;
          } else {
            let defaultcso = {ROLE_POSITION_CODE:CSONAME}
            this.listCSO.unshift(defaultcso);
            this.editData.CSO = defaultcso
          }
        })
        .catch((err) => {
          //  console.log(err);
          this.isPreparingForm = false;
          this.showSnackbar(err.toString());
        });
    },
    loadDataTable() {
      this.dtLoading = true;
      this.$http
        .post("/structure/mapping-sales-rep-assignment/select", {
          orgID: JSON.parse(localStorage.getItem("userData")).ORG_ID,
        }, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          console.log(res);
          let [arrayList] = res.data.data;
          this.dtLoading = false;

          arrayList.forEach((obj, index) => {
            arrayList[index].SALESREP_START_DATE = moment(
              arrayList[index].SALESREP_START_DATE
            ).format("DD MMM YYYY");
            arrayList[index].SALESREP_END_DATE = moment(
              arrayList[index].SALESREP_END_DATE
            ).format("DD MMM YYYY");
            let positionCodeHcm = "-";
            if( arrayList[index].POSITION_CODE_HCM!=0){
              arrayList[index].POSITION_CODE_HCM =arrayList[index].POSITION_CODE_HCM;
            }else{
              arrayList[index].POSITION_CODE_HCM =positionCodeHcm;
            }
          
          });
          this.dtItems = arrayList;
        })
        .catch((err) => {
          this.dtLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    verificationEndDate() {
      if (!moment(this.editData.ENDDATE).isAfter(this.editData.STARTDATE)) {
        this.editData.ENDDATE = moment(this.editData.STARTDATE)
          .endOf("months")
          .format("YYYY-MM-DD");
      }
    },
    getDataSalesRepData(value) {
      console.log('value', value);
      
      this.isOpenModalPopupEdit = true;
      this.dtHistoryLoading = true;

      this.editData.SALESREP_EMPLOYEEID = value.SALESREP_EMPLOYEEID;
      this.editData.SALESREP_POSITION_CODE = value.SALESREP_POSITION_CODE;
      this.editData.SALESREPEMPLOYEENAME = value.SALESREP_EMPLOYEE_NAME;
      this.editData.SALESREPEMPLOYEEID = value.SALESREP_EMPLOYEEID;

      if (value.SALESREP_START_DATE == "Invalid date") {
        this.editData.STARTDATE = moment().startOf("month").format("YYYY-MM-DD");
        this.editData.ENDDATE = moment("4001-12-31").format("YYYY-MM-DD");
      } else {
        this.editData.STARTDATE = moment(new Date(value.SALESREP_START_DATE)).format(
          "YYYY-MM-DD"
        );
        this.editData.ENDDATE = moment(new Date(value.SALESREP_END_DATE)).format(
          "YYYY-MM-DD"
        );
      }
      this.editData.SALESREPTITLECODE = value.SALESREP_TITLE_CODE;
      this.editData.SUPERVISOR = value.SUPERVISOR;
      this.editData.CSO = value.CSO;
      this.loadLOVPosition(value.Branch, value.SALESREP_POSITION_CODE, value.SALESREP_EMPLOYEEID);
      this.loadLOVCSO(value.SALESREP_POSITION_CODE, value.CSO, value.ORG_ID)

      if (value.SALESREP_POSITION_CODE && value.SALESREP_TITLE_CODE) {
      }

      this.$http
        .post("/structure/mapping-sales-rep-assignment/selectHistorybySalesrepID", {
          employeeID: value.SALESREP_EMPLOYEEID,
        }, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          this.dtHistoryLoading = false;
          const data = res.data.data;
          console.log('databaru ', data)
          this.dtItemHistory = data;
        })
        .catch((err) => {
          this.dtHistoryLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    changePosition() {
      console.log('this.selectedPosition ', this.selectedPosition)
      this.editData.BRANCH_CODE = this.selectedPosition.BRANCH_CODE;
      this.editData.ORG_ID = this.selectedPosition.ORG_ID;
      this.editData.EMPLOYEETYPEID = this.selectedPosition.EMPLOYEE_TYPE_ID;
      this.editData.EMPLOYEETYPECODE = this.selectedPosition.EMPLOYEE_TYPE_CODE;
      this.editData.ROLEMAPID = this.selectedPosition.ROLE_MAP_ID;
      this.editData.SALESREPPOSITIONCODE = this.selectedPosition.ROLE_POSITION_CODE;
      this.editData.EMPLOYEETITLEID = this.selectedPosition.EMPLOYEE_TITLE_ID;
      this.editData.SALESREPTITLECODE = this.selectedPosition.EMPLOYEE_TITLE_CODE;
      this.editData.SUPERVISOR = this.selectedPosition.ROLE_SUP_CODE;
      this.editData.CSO = this.selectedPosition.CSO_CODE;
      this.editData.USERIDUPDATE = JSON.parse(localStorage.getItem("userData")).USER_ID;

      //  console.log(this.editData)
    },

    changeCSO(value) {
      this.editData.CSO = value.ROLE_POSITION_CODE;
    },
    submit() {
      this.isLoading = true;

      let data = {
        BRANCHCODE: this.editData.BRANCH_CODE,
        ORGID: this.editData.ORG_ID,
        SALESREPEMPLOYEEID: this.editData.SALESREPEMPLOYEEID,
        SALESREPEMPLOYEENAME: this.editData.SALESREPEMPLOYEENAME,
        EMPLOYEETYPEID: this.editData.EMPLOYEETYPEID,
        EMPLOYEETYPECODE: this.editData.EMPLOYEETYPECODE,
        ROLEMAPID: this.editData.ROLEMAPID,
        SALESREPPOSITIONCODE: this.editData.SALESREPPOSITIONCODE,
        EMPLOYEETITLEID: this.editData.EMPLOYEETITLEID,
        SALESREPTITLECODE: this.editData.SALESREPTITLECODE,
        SUPERVISOR: this.editData.SUPERVISOR,
        CSO: this.editData.CSO,
        STARTDATE: this.editData.STARTDATE,
        ENDDATE: this.editData.ENDDATE,
        USERIDUPDATE: this.editData.USERIDUPDATE,
      };

       console.log("PAYLOAD : ", data);

      this.$http
        .post("/structure/mapping-sales-rep-assignment/insert", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          //  console.log("RESPONSE API : ", res);
          if (res.data.success) {
            this.editData = [];
            this.loadDataTable();
            this.showSnackbar("Success Update Data !");
            this.isLoading = false;
            this.isOpenModalPopupEdit = false;
            this.isOpenModalConfirm = false;
          } else {
            this.isOpenModalConfirm = false;
            this.isLoading = false;
            this.showSnackbar(res.data.message);
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    cutoff() {
      this.isLoading = true;

      let data = {
        SALESREPEMPLOYEEID: this.editData.SALESREP_EMPLOYEEID,
        SALESREPPOSITIONCODE: this.editData.SALESREP_POSITION_CODE,
        ENDDATE: this.editData.ENDDATE,
        USERIDUPDATE: this.editData.USERIDUPDATE,
      };

      //  console.log(data);

      this.$http
        .post("/structure/mapping-sales-rep-assignment/cutoff", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          //  console.log(res);
          if (res.data.success) {
            this.editData = [];
            this.showSnackbar("Success Cut Off Data !");
            this.isLoading = false;
            this.isOpenModalPopupEdit = false;
            this.isOpenModalConfirm = false;
            this.loadDataTable();
          } else {
            this.selectedPosition = [];
            this.editData.BRANCH_CODE = "";
            this.editData.ORG_ID = "";
            this.editData.EMPLOYEETYPEID = "";
            this.editData.EMPLOYEETYPECODE = "";
            this.editData.ROLEMAPID = "";
            this.editData.SALESREPPOSITIONCODE = "";
            this.editData.EMPLOYEETITLEID = "";
            this.editData.SALESREPTITLECODE = "";
            this.editData.SUPERVISOR = "";
            this.editData.USERIDUPDATE = "";
            this.isOpenModalConfirm = false;
            this.isLoading = false;
            this.showSnackbar(res.data.message);
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
  },
};
</script>
